/* eslint-disable parog-web/no-glint-expect-error-directive */
import PathologyFields from '../breast-cancer/pathology-fields';

<template>
  {{! @glint-expect-error }}
  <PathologyFields @form={{@form}} />
</template>
